import * as types from "./cnae.actionTypes";

export default {
  setSagaCnae: (data) => ({
    type: types.SET_SAGA_CNAE,
    payload: data,
  }),
  setCnae: (data) => ({
    type: types.SET_CNAE,
    payload: data,
  }),
  addSagaCnae: (data) => ({
    type: types.ADD_SAGA_CNAE,
    payload: data,
  }),
  addCnae: (data) => ({
    type: types.ADD_CNAE,
    payload: data,
  }),
  deleteSagaCnae: (data) => ({
    type: types.DELETE_SAGA_CNAE,
    payload: data,
  }),
  deleteCnae: (data) => ({
    type: types.DELETE_CNAE,
    payload: data,
  }),
  mainSagaCnae: (data) => ({
    type: types.MAIN_SAGA_CNAE,
    payload: data,
  }),
  mainCnae: (data) => ({
    type: types.MAIN_CNAE,
    payload: data,
  }),
  loadIdsCnae: () => ({
    type: types.LOAD_IDS_CNAE,
  }),
  onChange: (data) => ({
    type: types.ON_CHANGE_CNAE,
    payload: data,
  }),
  AdicionaAutomaticamenteAtividadePorCnae: () => ({
    type: types.ADICIONA_AUTOMATICAMENTE_ATIVIDADE,
  })
};
